import { useMutation } from '@apollo/client';
import {
  GET_PORTALIO_AUTH_DETAILS,
  PORTALIO_CONNECT,
} from 'src/graphql/entities/integrations/portalio/portalio.operations';
import { useCurrentUserProfile } from 'src/graphql/entities/platform-user';
import { WithId } from 'src/graphql/types';
import { PortalioAuthDetail } from 'src/pages/Settings/integrations/portalio/portalio-auth-details';
import { PortalioAuthResponse } from 'src/pages/Settings/integrations/portalio/portalio-integration-view';
import { useNotifications } from 'src/utils/hooks';

export type PortalioAuthenticateQuery = {
  portalioAuthenticate: {
    authDetails: WithId<PortalioAuthDetail>;
  };
};

export type PortalioAuthenticateQueryVariables = {
  params: {
    userName: string;
    password: string;
  };
};

export const usePortalioConnect = () => {
  const { showErrorAlert } = useNotifications();
  const { user } = useCurrentUserProfile();

  const [connect] = useMutation<PortalioAuthenticateQuery, PortalioAuthenticateQueryVariables>(
    PORTALIO_CONNECT,
    {
      optimisticResponse: (vars) => {
        return {
          portalioAuthenticate: {
            authDetails: {
              id: vars.params.userName,
              userId: user?.id ?? 'userId',
              portalioUserName: vars.params.userName,
            },
          },
        };
      },
      update: (cache, result) => {
        if (!result.data?.portalioAuthenticate.authDetails) {
          return;
        }
        cache.writeQuery<PortalioAuthResponse>({
          query: GET_PORTALIO_AUTH_DETAILS,
          data: {
            getPortalioUserAuthDetails: {
              authDetails: result.data?.portalioAuthenticate.authDetails,
            },
          },
        });
      },
      onError: (data) => {
        showErrorAlert(data.message);
      },
    },
  );

  return {
    connect,
  };
};
